import * as d3 from 'd3';

class NanoChart {
  count;
  countOf;
  countColor;
  countOfColor;

  constructor(public $element) {
    'ngInject';
  }

  // This redrawing of the graph is probably rather crude but it gets the job done.
  $onChanges(changes) {
    this.drawGraph();
  }

  $onInit() {
    this.drawGraph();
  }

  drawGraph() {
    let dataset = [
      { label: 'Complete', count: this.count },
      { label: 'Incomplete', count: this.countOf - this.count }
    ];

    let width = 26;
    let height = 26;
    let radius = Math.min(width, height) / 2;
    let completeColor = d3.color(this.countColor || 'black');
    let incompleteColor = d3.color(this.countOfColor || 'white');

    // Switch this to a function so we get the right color for all the sections of the graph.
    let color = (label) => {
      switch (label) {
        case 'Complete':
          return completeColor;
        case 'Incomplete':
          return incompleteColor;
      }
    };

    // Find the embedded SVG element underneath this element. Because we're only searching within this element,
    // we won't accidentally do anything to another graph just like it next to this one.
    let rawSvg = this.$element.find('svg')[0];

    // Without this, calling the drawGraph multiple times will just pile up one <g>...</g> on top of another
    // within this chart. It looks fine but the actual SVG is redundant (and wrong).
    d3.select(rawSvg).select('g').remove();

    // Move the graph to the center of the area.
    let svg = d3
      .select(rawSvg)
      .append('g')
      .attr('transform', `translate(${width / 2},${height / 2})`);

    // This draws the thick donut shape in our desired color.
    svg
      .append('circle')
      .attr('r', 8.5)
      .attr('fill', 'transparent')
      // @ts-ignore
      .attr('stroke', completeColor)
      .attr('stroke-width', 8);

    // And then atop that donut we draw a circle with one segment for the completed amount and another for the
    // incomplete amount.
    let arc = d3
      .arc()
      .innerRadius(7)
      .outerRadius(radius - 3);

    let pie = d3
      .pie()
      .value((d) => d.count)
      .sort(null);

    // @ts-ignore
    svg
      .selectAll()
      .data(pie(dataset))
      .enter()
      .append('path')
      .attr('d', arc)
      .attr('fill', (d) => color(d.data.label));
  }
}

export const NanoDonutComponent = {
  bindings: {
    count: '<',
    countOf: '<',
    countColor: '<',
    countOfColor: '<'
  },
  controller: NanoChart,
  template: `<svg width="26" height="26"></span>`
};
